module.exports = __webpack_public_path__ + "img/group.10b719d9.svg";